export default "<body>\r\n  <app-nav-menu></app-nav-menu>\r\n  <div>\r\n    <router-outlet></router-outlet>\r\n  </div>\r\n</body>\r\n"